export enum FormIds {
  FirstName = 'firstName',
  LastName = 'lastName',
  PhoneNumber = 'phoneNumber',
  BirthDate = 'birthDate',
  Email = 'email',
  Address = 'addressData',
  YearIncome = 'yearIncome'
}
